import type { CSSProperties, ElementType, HTMLAttributes, ReactNode } from 'react';
import { useInView } from '@/hooks/use-motion';
import { cn } from '@/lib/utils';

interface Props extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  as?: ElementType;
  /** Stagger delay in ms. */
  delay?: number;
  variant?: 'up' | 'left' | 'right' | 'zoom';
}

/** Fades/slides its children in when they scroll into view. Other props (aria-*, id…) pass through. */
export function Reveal({
  children,
  as: Tag = 'div',
  delay = 0,
  variant = 'up',
  className,
  style,
  ...rest
}: Props) {
  const { ref, visible } = useInView<HTMLElement>();
  return (
    <Tag
      {...rest}
      ref={ref}
      data-variant={variant}
      className={cn('reveal', visible && 'is-visible', className)}
      style={{ ...style, '--delay': `${delay}ms` } as CSSProperties}
    >
      {children}
    </Tag>
  );
}
